import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";

import Notfound from "./shared/notfound";
import LoginScreen from "./login/LoginScreen";
import DashboardScreen from "./dashboard/DashboardScreen";
import GestioneAvpScreen from "./avp/GestioneAvpScreen";
import GestioneAvpDetailScreen from "./avp/GestioneAvpDetailScreen";
import GestioneAvpGrafoScreen from "./avp/GestioneAvpGrafoScreen";
import GestioneAvpIstanzeScreen from "./avp/GestioneAvpIstanzeScreen";
import GestioneAvpIstanzeDetailScreen from "./avp/GestioneAvpIstanzeDetailScreen";
import GestioneUtentiScreen from "./utenti/GestioneUtentiScreen";
import GestioneContenutiScreen from "./contenuti/GestioneContenutiScreen";
import GestioneContenutiFileScreen from "./contenuti/GestioneContenutiFileScreen";
import GestioneContenutiPickScreen from "./contenuti/GestioneContenutiPickScreen";
import GestioneSistemaScreen from "./sistema/GestioneSistemaScreen";
import GestioneAvpArcoScreen from "./avp/GestioneAvpArcoScreen";
import NewGestioneArcoScreen from "./new-avp/new-gestione-arco";
import GestioneAvpContentPlaylistFileScreen from "./avp/GestioneAvpContentPlaylistFileScreen";
import GestioneContenutiFolderScreen from "./contenuti/GestioneContenutiFolderScreen";
import GestioneContenutiAvatarScreen from "./contenuti/GestioneContenutiAvatarScreen";
import GestioneAgentAIScreen from "./contenuti/GestioneAgentAIScreen";
import GestioneAgentListScreen from "./contenuti/GestioneAgentsListScreen";
import GestioneUtenteDetailScreen from "./utenti/GestioneUtenteDetailScreen";
import GestioneGruppiUtenteScreen from "./utenti/GestioneGruppiUtenteScreen";
import GestioneGruppoUtenteDetailScreen from "./utenti/GestioneGruppoUtenteDetailScreen";
import GestioneSistemaDetailScreen from "./sistema/GestioneSistemaDetailScreen";
import PasswordRecoverScreen from "./login/PasswordRecoverScreen";
import GestioneLingueScreen from "./sistema/GestioneLinguaScreen";
import GestioneLingueDetailScreen from "./sistema/GestioneLinguaDetailScreen";
import NewGraphScreen from "./new-avp/new-graph-screen";
import { useLingueStore } from "./sistema/storeLingua";
import { useEffect } from "react";
import RedirectScreen from "./RedirectScreen";
function App() {
  const { refreshLingua } = useLingueStore((state) => state);

  useEffect(() => {
    refreshLingua();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<DashboardScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/passwordrecover" element={<PasswordRecoverScreen />} />

        <Route path="/avp" element={<GestioneAvpScreen />} />
        <Route path="/avp/*" element={<GestioneAvpDetailScreen />} />

        <Route path="/avp/grafo/*" element={<NewGraphScreen />} />
        {/* <Route path="/avp/grafo/*" element={<GestioneAvpGrafoScreen />} /> */}

        <Route
          path="/avp/grafo/nodo/arco"
          element={<NewGestioneArcoScreen />}
        />
        {/* <Route path="/avp/grafo/nodo/arco" element={<GestioneAvpArcoScreen />} /> */}

        <Route
          path="/avp/grafo/nodo/playlistfile"
          element={<GestioneAvpContentPlaylistFileScreen />}
        />
        <Route
          path="/avp/redirect"
          element={<RedirectScreen />}
        />
        <Route path="/avp/istanze" element={<GestioneAvpIstanzeScreen />} />
        <Route
          path="/avp/istanze/*"
          element={<GestioneAvpIstanzeDetailScreen />}
        />
        <Route path="/utenti" element={<GestioneUtentiScreen />} />
        <Route path="/utenti/*" element={<GestioneUtenteDetailScreen />} />
        <Route path="/utenti/gruppi" element={<GestioneGruppiUtenteScreen />} />
        <Route
          path="/utenti/gruppi/*"
          element={<GestioneGruppoUtenteDetailScreen />}
        />
        <Route path="/contenuti" element={<GestioneContenutiScreen />} />
        <Route
          path="/contenuti/pick"
          element={<GestioneContenutiPickScreen />}
        />
        <Route
          path="/contenuti/file"
          element={<GestioneContenutiFileScreen />}
        />
        <Route
          path="/contenuti/avatar"
          element={<GestioneContenutiAvatarScreen />}
        />
        <Route path="/contenuti/agent" element={<GestioneAgentAIScreen />} />
        <Route
          path="/contenuti/agent/list"
          element={<GestioneAgentListScreen />}
        />
        <Route
          path="/contenuti/folder/*"
          element={<GestioneContenutiFolderScreen />}
        />
        <Route path="/sistema" element={<GestioneSistemaScreen />} />
        <Route path="/sistema/lingue" element={<GestioneLingueScreen />} />
        <Route
          path="/sistema/lingue/*"
          element={<GestioneLingueDetailScreen />}
        />
        <Route path="/sistema/*" element={<GestioneSistemaDetailScreen />} />

        <Route component={Notfound} />
      </Routes>
    </Router>
  );
}

export default App;

// preview_name: "",
//         typeVoice: "",
//         voice_id: "",
//         languageVoice: "",
//         source_url: "",
